import React, {memo, useCallback} from 'react';
import {useNavigation} from '@react-navigation/native';

import ErrorBoundaryProvider from './ErrorBoundaryProvider';
interface ErrorBoundaryProviderContainerProps {
  hasBack: boolean;
  [key: string]: any;
}

const ErrorBoundaryProviderContainer = ({
  hasBack = false,
  ...props
}: ErrorBoundaryProviderContainerProps) => {
  const navigation = useNavigation();

  const onGoBack = useCallback(
    () => hasBack && navigation.canGoBack() && navigation.goBack(),
    [hasBack, navigation],
  );

  return (
    <ErrorBoundaryProvider {...props} onGoBack={onGoBack} hasBack={hasBack} />
  );
};

export default memo(ErrorBoundaryProviderContainer);
